import { MonetizationType, PresentationType } from '@/@types/graphql-types';
import { useLanguageStore, useSportsStore } from '@/helpers/composables/useStores';
import { ComputedRef, onMounted, onServerPrefetch } from 'vue';

interface SportPromotion {
	eventIds?: string[];
	package: {
		packageId: number;
		technicalName: string;
		clearName: string;
		shortName: string;
		iconUrl: string;
	};
	monetizationType: MonetizationType;
	presentationType: PresentationType;
	standardWebURL: string;
	countries: string[];
	startDate: string;
	endDate: string;
	title: string | null;
	subtitle: string | null;
}

function sportsPromotions(country: string): SportPromotion[] {
	return [
		// ESPN, Disney+, and Hulu bundle
		{
			package: {
				packageId: 1768,
				shortName: 'epp',
				technicalName: 'espnplus',
				clearName: 'ESPN Plus',
				iconUrl: '/icon/334903070/s100/image.{format}',
			},
			monetizationType: MonetizationType.Flatrate,
			presentationType: PresentationType.Hd,
			standardWebURL:
				'https://disneyplus.bn5x.net/G5y0r?u=https%3A%2F%2Fwww.disneyplus.com%2Fwelcome%2Fdisney-hulu-espn-bundle',
			countries: ['US'],
			startDate: '2025-08-22',
			endDate: '2025-09-03',
			title: 'Disney+, Hulu, ESPN Bundle',
			subtitle: 'Get all three for the price of just ESPN for a year',
		},
		{
			package: {
				packageId: 15,
				shortName: 'hlu',
				technicalName: 'hulu',
				clearName: 'Hulu',
				iconUrl: '/icon/116305230/s100/hulu.{format}',
			},
			monetizationType: MonetizationType.Flatrate,
			presentationType: PresentationType.Hd,
			standardWebURL:
				'https://www.hulu.com/live-sports?cmp=13017&utm_campaign=brand&utm_source=Affiliate&utm_medium=Klay+Media&our_click_id=41570649bc124f2d8f76df2db23406d9',
			countries: ['US'],
			startDate: '2026-02-06',
			endDate: '2026-02-09',
			title: 'Super Bowl LX',
			subtitle: 'Stream Super Bowl LX live on Hulu + Live TV',
		},
	];
}

export function getSportsPromotion() {
	const { country } = useLanguageStore();

	// Priority is determined by position in the array. The first item has the highest priority.
	const promotions = sportsPromotions(country.value).filter(promotion => {
		const currentDate = new Date();
		return (
			promotion.countries.includes(country.value) &&
			Number(currentDate) > new Date(promotion.startDate).setUTCHours(0, 0, 0, 0) &&
			Number(currentDate) < new Date(promotion.endDate).setUTCHours(23, 59, 59, 999)
			// && promotion.eventIds.includes(eventId)
		);
	});
	return { promotions };
}

export function useSportsPromotion() {
	const { setSportsPromotions, sportsPromotions } = useSportsStore();

	onServerPrefetch(async () => await setSportsPromotions());

	onMounted(async () => await setSportsPromotions());

	return {
		sportsPromotions: sportsPromotions as ComputedRef<{ promotions: SportPromotion[] }>,
	};
}
